<template>
  <div
    style="text-align: right;"
    class="customer-order-actions"
  >
    <el-dropdown
      ref="dropDown"
      size="small"
      @command="handleAction"
    >
      <el-button
        size="mini"
        class="el-dropdown-link"
        @click.stop="toggleDropDown"
      >
        <i :class="!buttonLoader ? 'el-icon-more' : 'el-icon-loading'" />
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-can="'customerorder.create'"
          :command="copyCustomerOrder"
          :disabled="buttonLoader"
        >
          <i class="el-icon-document-copy" /> Másolás
        </el-dropdown-item>
        <el-dropdown-item
          v-can="'customerorder.view'"
          v-if="customerOrder.status !== 'recorded' && customerOrder.status !== 'cancelled' && customerOrder.receipt_file_url"
          :command="openReceipt"
          :disabled="buttonLoader"
        >
          <i class="el-icon-printer" /> Bizonylat nyomtatása
        </el-dropdown-item>
        <el-dropdown-item
          v-can="'customerorder.update'"
          v-if="customerOrder.status === 'partly-done' && !customerOrder.has_no_more_delivery"
          :command="setHasNoMoreDelivery"
          :disabled="buttonLoader"
        >
          <i class="el-icon-truck" /> Nem lesz több szállítás
        </el-dropdown-item>
        <el-dropdown-item
          v-can="'customerorder.update'"
          v-if="customerOrder.status === 'partly-done' && customerOrder.has_no_more_delivery"
          :command="setHasNoMoreDelivery"
          :disabled="buttonLoader"
        >
          <i class="el-icon-truck" /> Lesz még szállítás
        </el-dropdown-item>
        <el-dropdown-item
          v-can="'customerorder.update'"
          v-if="customerOrder.status === 'cancelled'"
          :command="undoCancelCustomerOrder"
          :disabled="buttonLoader"
        >
          <i class="el-icon-refresh-left" /> Lemondás visszavonása
        </el-dropdown-item>
        <el-dropdown-item
          v-can="'customerorder.update'"
          v-if="customerOrder.status === 'sent'"
          :command="cancelCustomerOrder"
          :disabled="buttonLoader"
        >
          <i class="el-icon-close" /> Megrendelés lemondása
        </el-dropdown-item>
        <el-dropdown-item
          v-can="'customerorder.update'"
          v-if="customerOrder.status === 'recorded'"
          :command="sendOrder"
          :disabled="buttonLoader"
        >
          <i class="el-icon-box" /> Küldés a raktárnak
        </el-dropdown-item>
        <el-dropdown-item
          v-can="'customerorder.update'"
          :command="updateRcustomerOrder"
          :disabled="buttonLoader"
        >
          <i class="el-icon-edit" /> Módosítás
        </el-dropdown-item>
        <el-dropdown-item
          v-if="customerOrder.status === 'recorded'"
          v-can="'customerorder.delete'"
          :command="openDeleteConfirmation"
          :disabled="buttonLoader"
        >
          <i class="el-icon-delete" /> Törlés
        </el-dropdown-item>
        <el-dropdown-item
          :command="exportExcel"
          :disabled="buttonLoader"
        >
          <i class="el-icon-download" /> Excel exportálás
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
  export default {
    props: ['customerOrder'],
    data() {
      return {
        buttonLoader: false,
        deleteConfirmVisible: false,
      };
    },

    methods: {
      async deleteRcustomerOrder() {
        this.buttonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('customerOrder/delete', this.customerOrder.id);
          this.$store.dispatch('customerOrder/fetchAll');
        } catch (e) {
        }
        this.buttonLoader = false;
      },
      async updateRcustomerOrder() {
        this.$router.push('/sales/customer-orders/update/' + this.customerOrder.id);
      },
      async sendOrder() {
        this.buttonLoader = true;
        try {
          await this.$store.dispatch('customerOrder/send', this.customerOrder.id);
          this.$store.dispatch('customerOrder/fetchAll');
        } catch (e) {
        }
        this.buttonLoader = false;
      },
      async cancelCustomerOrder() {
        this.buttonLoader = true;
        try {
          await this.$store.dispatch('customerOrder/cancel', this.customerOrder.id);
          this.$store.dispatch('customerOrder/fetchAll');
        } catch (e) {
        }
        this.buttonLoader = false;
      },
      async undoCancelCustomerOrder() {
        this.buttonLoader = true;
        try {
          await this.$store.dispatch('customerOrder/undoCancel', this.customerOrder.id);
          this.$store.dispatch('customerOrder/fetchAll');
        } catch (e) {
        }
        this.buttonLoader = false;
      },
      copyCustomerOrder() {
        this.$router.push('/sales/customer-orders/add/' + this.customerOrder.id);
      },
      async setHasNoMoreDelivery() {
        this.buttonLoader = true;
        try {
          await axios.put(`api/customer-orders/${this.customerOrder.id}/has-no-more-delivery`, {
            has_no_more_delivery: !this.customerOrder.has_no_more_delivery
          })
          this.$store.dispatch('customerOrder/fetchAll');
        } catch (e) {
        }
        this.buttonLoader = false;
      },
      async openReceipt() {
        if (this.customerOrder.receipt_file_url) {
          this.buttonLoader = true;
          try {
            const url = await axios.get('api/files?path=' + this.customerOrder.receipt_file_url);
            window.open(url);
          } catch (e) {
            console.log(e)
          }
          this.buttonLoader = false;
        }
      },
      openDeleteConfirmation() {
        this.$confirm('Ez a folyamat nem visszafordítható és a kapcsolódó elemek is törölve lesznek.', 'Biztosan törölni szeretnéd?', {
          confirmButtonText: 'Igen',
          cancelButtonText: 'Mégse',
          type: 'warning',
        })
        .then(() => {
          this.deleteRcustomerOrder();
        })
        .catch(() => {
          this.$router.replace('/sales/customer-orders');
        });
      },
      handleAction(action) {
        action();
      },
      toggleDropDown() {
        this.$refs['dropDown'].visible = !this.$refs['dropDown'].visible;
      },
      async exportExcel() {
        try {
          this.buttonLoader = true;
          const excel = await axios({
            url: 'api/customer-orders/' + this.customerOrder.id + '/export',
            method: 'GET',
            responseType: 'blob',
          });
          saveAs(excel, 'customer_order_items.xlsx');
        } catch (e) {
        }
        this.buttonLoader = false;

      },
    }
  };
</script>
<style lang="scss">
  .customer-order-actions {
    padding: 0 !important;
    float: right;
    line-height: 1;

    .el-dropdown {
      padding-right: 0;
    }
  }
</style>
